import { render, staticRenderFns } from "./header-new.vue?vue&type=template&id=63b74ac2&scoped=true&"
import script from "./header-new.vue?vue&type=script&lang=js&"
export * from "./header-new.vue?vue&type=script&lang=js&"
import style0 from "./header-new.vue?vue&type=style&index=0&id=63b74ac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b74ac2",
  null
  
)

export default component.exports